import {
	SankeyType,
	SwitchingSankeyNode,
	SwitchingSankeyNodes,
} from "components/CustomerBehavior/Switching/interfaces"
import {
	LIMITED_TITLE,
	SANKEY_TYPE,
} from "components/CustomerBehavior/Switching/SankeySwitching/constants"
import { formatNumber } from "helpers/numbers"
import { IntlShape } from "react-intl"

const formatNodeTitle = (title: string, value: string) => {
	const titleLimited =
		title.length > LIMITED_TITLE ? title.slice(0, LIMITED_TITLE) + "..." : title
	return `${titleLimited} (${value})`
}

export const mapSankeyNodes = (
	type: SankeyType,
	total: number,
	intl: IntlShape
) => (node: SwitchingSankeyNode) => {
	const { target, source, value } = node
	const totalFormatted = formatNumber(total, intl)
	const valueFormatted = formatNumber(value, intl)

	if (type === SANKEY_TYPE.LOSSES) {
		return {
			target: formatNodeTitle(target, totalFormatted),
			source: formatNodeTitle(source, valueFormatted),
			value,
		}
	}

	return {
		target: formatNodeTitle(target, valueFormatted),
		source: formatNodeTitle(source, totalFormatted),
		value,
	}
}

const mapToSwitchingSankey = (
	data: {
		nodes: SwitchingSankeyNode[]
		totalSwitching: number
	},
	type: SankeyType,
	intl: IntlShape
) => {
	const { nodes = [], totalSwitching } = data
	const totalEarnings = formatNumber(totalSwitching, intl)
	const nodesWithAmountProfit = nodes.map(
		mapSankeyNodes(type, totalSwitching, intl)
	)

	return {
		nodes: nodesWithAmountProfit,
		totalSwitching: totalEarnings,
	}
}

export const mapToSankeyUI = (data: SwitchingSankeyNodes, intl: IntlShape) => {
	const { profits, losses, totalSwitching } = data
	const profitMapped = mapToSwitchingSankey(profits, SANKEY_TYPE.PROFITS, intl)
	const lossesMapped = mapToSwitchingSankey(losses, SANKEY_TYPE.LOSSES, intl)
	const totalSwitchingFormatted = formatNumber(totalSwitching, intl)

	return {
		profit: profitMapped,
		losses: lossesMapped,
		totalSwitching: totalSwitchingFormatted,
	}
}
